module.exports = __webpack_public_path__ + "img/5.4299d914.jpeg";